export const AUTH_API = process.env.REACT_APP_AUTH_API;
export const APP_API = process.env.REACT_APP_APP_API;
export const VNPT_LICENSE = process.env.REACT_APP_VNPT_LICENSE;
export const IS_EPAYZ = !!process.env.REACT_APP_IS_EPAYZ;
